import React, { use } from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import DesoResidentTransmitterImage from 'assets/images/deso-resident-transmitter.png';
import G2TransmitterImage from 'assets/images/g2-transmitter.png';
import { DeviceType } from 'shared/models/device-type';

import LinkableTransmitterStepsProviderContext from 'features/residents/resident-settings/components/resident-setting-details/components/devices-accordion/components/details-devices/components/linkable-transmitter-steps/providers/contexts/linkable-transmitter-steps-provider-context';
import styles from './confirmation-step.module.scss';

const ConfirmationStep = (): React.JSX.Element => {
  const { t: tDeviceTypes } = useTranslation('deviceTypes');
  const { t } = useTranslation('residentsSettings', { keyPrefix: 'linkableDevicesModal.linkableTransmitterSteps' });
  const {
    form: { watch },
  } = use(LinkableTransmitterStepsProviderContext);
  const typeWatch = watch('type');
  const externalId = watch('externalId');

  const renderImage = (): React.JSX.Element => {
    switch (typeWatch) {
      case DeviceType.G2Transmitter:
        return <img src={G2TransmitterImage} alt="G2 Transmitter" />;
      case DeviceType.DesoResidentTransmitter:
        return <img src={DesoResidentTransmitterImage} alt="Deso Resident Transmitter" />;
      default:
        return <></>;
    }
  };

  return (
    <div className={styles.confirmationStepContainer}>
      <div className={styles.typeCard}>
        <div className={styles.leftColumn}>
          <Typography variant="h6">
            {t('type')}: {tDeviceTypes(typeWatch)}
          </Typography>
          <Typography variant="h6">
            {t('deviceExternalId')}: {externalId}
          </Typography>
        </div>
        <div className={styles.rightColumn}>{renderImage()}</div>
      </div>
    </div>
  );
};

export default ConfirmationStep;
